import React, { useEffect, useState, useContext, useCallback } from "react";
import { useForm, Controller, useWatch, FormProvider } from "react-hook-form";
import { Link, Routes, Route, useHistory, useLocation } from "react-router-dom";
import ModalSelectTableCustom from "../../Components/ModalSelectTableCustom";

import { withStyles, makeStyles } from "@material-ui/core/styles";
import {
  Row,
  Col,
  Form,
  Alert,
  Button,
  Container,
  Modal,
} from "react-bootstrap";

import axios from "axios";

import AADService from "../../auth/authFunctions";

import PropTypes from "prop-types";

import Loader from "react-loader-spinner";
import Checkbox from "@material-ui/core/Checkbox";
import Radio from "@material-ui/core/Radio";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import AddBoxIcon from "@mui/icons-material/AddBox";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableContainer from "@material-ui/core/TableContainer";
import FormControlLabel from "@mui/material/FormControlLabel";
import TablePagination from "@material-ui/core/TablePagination";
import { AiFillDelete, AiFillCaretDown } from "react-icons/ai";
import { MdAddCircleOutline } from "react-icons/md";
import Switch from "@material-ui/core/Switch";
import Select from "react-select";
import makeAnimated from "react-select/animated";

import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";

import ModalAsociarProveedor from "./Modales/ModalAsociarProveedor";
import ModalAsociarControl from "./Modales/ModalAsociarControl";

import { FormSearchListSiNoNa } from "../../form-components/FormSearchListSiNoNa";
import { FormSearchListCompania } from "../../form-components/FormSearchListCompania";

import Queries from "../../Components/QueriesAxios";

const _ = require("lodash");

// function TabPanel(props) {
//   const { children, value, index, ...other } = props;
//   return (
//     <div
//       role="tabpanel"
//       hidden={value !== index}
//       id={`simple-tabpanel-${index}`}
//       aria-labelledby={`simple-tab-${index}`}
//       {...other}
//     >
//       {value === index && (
//         <Box style={{ padding: "0.5%" }} p={3}>
//           <Typography component="div" style={{ padding: "0.5%" }}>
//             {children}
//           </Typography>
//         </Box>
//       )}
//     </div>
//   );
// }

const animatedComponents = makeAnimated();

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#2c2a29",
    color: theme.palette.common.white,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    backgroundColor: "#f4f4f4",
    heigth: "10px",
  },
}))(TableRow);

const useStyles = makeStyles({
  root: {
    maxWidth: "100vw",

    overflowX: "scroll",
  },

  container: {
    maxHeight: "57vh",

    minHeight: "50vh",

    maxWidth: "200vh",

    minWidth: "300vh",

    overflowX: "scroll",
  },
});

function AlertDismissibleExample({ alerta }) {
  switch (alerta.id) {
    case 1:
      return <Alert variant="warning">Alerta</Alert>;

    case 2:
      return <Alert variant="success">{alerta.data}</Alert>;

    case 3:
      return <Alert variant="danger">{alerta.data}</Alert>;

    case 4:
      return <Alert variant="warning">Error al enviar la información</Alert>;

    case 5:
      return <Alert variant="danger">Error en el servidor</Alert>;

    case 7:
      return (
        <Alert variant="warning">
          Corrige los siguientes errores:
          <br></br>• Debe completar los campos obligatorios
        </Alert>
      );
    default:
      return <p></p>;
  }
}
const defaultState = {
  id: "",
  nombre_atributo: "",
  fuente_atributo: "",
  area_captura: "",
  proceso_captura: "",
  estado: "",
  otroControles_atributos: "",
};

let controles = [];
let controlesDesaociados = [];
let dic_causa_controles = {};
let dataControlesAtributo = [];
let idControlesAtributo = [];

export default function EditarIpe(props) {
  const location = useLocation();
  let history = useHistory();
  const serviceAAD = new AADService();
  const classes = useStyles();
  const [valor, setValor] = React.useState(0);
  const [estadoPost, setEstadoPost] = useState({
    alerta: { id: 0, data: null },
  });
  const [id, setID] = useState(null);
  const [dataResponsable, setDataResponsable] = useState(null);
  const [dataAnalistaSox, setDataAnalistaSox] = useState(null);
  const [dataAnexo, setDataAnexo] = useState(null);
  const [dataAnexoEditar, setDataAnexoEditar] = useState(null);
  const [dataCompanias, setDataCompanias] = useState(null);  
  const [dataIpesClasi, setDataIpesClasi] = useState(null);
  const [idIpe, setIdIpe] = useState(null);
  const [dataArea, setDataArea] = useState([]);
  const [dataProceso, setDataProceso] = useState([]);
  const [dataControlesActivos, setDataControlesActivos] = useState([]);
  const [flagAsegura, setFlagAsegura] = useState(null);
  const [flagControla, setFlagControla] = useState(null);
  const [loadingData, setLoadingData] = React.useState(false);

  const [fuente, setFuente] = useState(null);
  const [realizaFiltro, setRealizaFiltro] = useState(false);
  const [filtro, setFiltro] = useState(false);
  const [regeneraIpe, setRegeneraIpe] = useState(null);
  const [realizaTransformacion, setRealizaTransformacion] = useState(false);
  const [clasificacionIpe, setClasificacionIpe] = useState(null);
  const [showModalAsociarProveedor, setShowModalAsociarProveedor] =
    useState(false);
  const [consultasBool, setConsultasBool] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const [dataProveedor, setDataProveedor] = useState([]);
  const [dataControles, setDataControles] = useState([]);
  const [dataControlesCheckbox, setDataControlesCheckbox] = useState([]);
  const [dataControlesAtributos, setDataControlesAtributos] = useState([]);
  const [otrosControles, setOtrosControles] = useState(null);
  const [showAsociarControles, setShowAsociarControles] = useState(false);
  const [selectedControles, setSelectedControles] = useState([]);
  const [aplicativo, setAplicativo] = useState(null);
  const [aplicaciones, setAplicaciones] = useState([]);
  const [showModApps, setShowModApps] = useState(false);
  const [checkedA1, setcheckedA1] = useState(false);
  const [checkedA2, setcheckedA2] = useState(false);
  const [checkedA3, setcheckedA3] = useState(false);
  const [checkedB, setcheckedB] = useState(false);
  const [checkedC, setcheckedC] = useState(false);
  const [checkedD, setcheckedD] = useState(false);
  const [checkedE, setcheckedE] = useState(false);
  const [itgc, setItgc] = useState(false); 
  const [companiaSelect, setCompaniaSelect] = useState(false);
  const [compania, setCompania] = useState(null);
  const [estadoipe, setEstadoIpe] = useState(null);
  
  //Para revisión segunda línea
  const [dataRevision, setDataRevision] = useState([]);
  const [dataAtributos, setDataAtributos] = useState([]);
  const [dataRevisionBool, setDataRevisionBool] = useState(true);
  const [dataAtributosBool, setDataAtributosBool] = useState(true);
  const [rowsPerPage, setRowsPerPage] = React.useState(100);
  const [page, setPage] = React.useState(0);
  const [selected, setSelected] = React.useState([]);
  const [dataTablePAs, setDataTablePAs] = useState(null);
  const [dataTableControl, setDataTableControl] = useState(null);
  const [indexPA, setIndexPA] = useState(null);
  const [indexControl, setIndexControl] = useState(null);
  const [showPAs, setShowPAs] = useState(false);
  const [showControls, setShowControls] = useState(false);
  const [paSelected, setPaSelected] = useState(null);
  const [controlSelected, setControlSelected] = useState(null);
  const [listaAristas, setListaAristas] = React.useState([]);
  const [strAristas, setStrAristas] = useState([]);
  //Para atributos
  const [rows, setRows] = useState([defaultState]);
  const [loadingDataAtributos, setLoadingDataAtributos] = React.useState(true);

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const isSelectedControles = (name) => selectedControles.indexOf(name) !== -1;

  const handleClickControles = (event, name) => {
    const selectedIndex = selectedControles.indexOf(name);

    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat([], name);
      //SetButtonEdit(true);
    } else {
      //SetButtonEdit(false);
    }

    setSelectedControles(newSelected);
  };

  const defaultValues = {
    idipe: null,
    nombre: null,
    compania: null,
    responsable_ipe: null,
    analista_sox: null,
    fuente_de_generacion: null,
    nombre_de_fuente: null,
    ruta_generacion_ipe: null,
    clasificacion_ipe: null,
    realiza_filtro: null,
    filtros: null,
    existe_transformacion: null,
    regenerar_ipe: null,
    ruta_evidencia_ipe: null,
    a1: null,
    a2: null,
    a3: null,
    b: null,
    c: null,
    d: null,
    itgc: null,
    otros_controles: null,
    atributos: null,
    revision: null,
    aristasEdit: null,  
  };

  const methods = useForm({
    defaultValues,
    mode: "onChange",
  });

  const {
    register,
    handleSubmit,
    control,
    setValue,
    getValues,
    reset,
    formState: { errors },
  } = methods;

  const camposDinamicos = () => {
    const campos = getValues([
      "fuente_de_generacion",
      "realiza_filtro",
      "regenerar_ipe",
      "existe_transformacion",
      "clasificacion_ipe",
    ]);

    if (campos[0].label === "Aplicativos") {
      setFuente(1);
    }
    if (campos[0].label === "RPA") {
      setFuente(2);
    }
    if (campos[0].label === "Proveedor") {
      setFuente(3);
    }
    if (campos[0].label === "Otros") {
      setFuente(4);
    }

    if (campos[1].label === "Si") {
      setRealizaFiltro("Si");
    }
  };

  const llenarFormulario = async (id) => {
    setLoadingData(true);
    console.log("llenar formulario")
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL + "/ipes/" + id,
        {
          headers: {
            Authorization: "Bearer " + serviceAAD.getToken(),
          },
        }
      );

      let data = response.data;
      setIdIpe(id);

      /*           const responseRevision = await axios.get(
        process.env.REACT_APP_API_URL + "/revisiones",
        {
          headers: {
            Authorization: "Bearer " + serviceAAD.getToken(),
          },
        }
      ); */

      /* let listaCategorias = responseCategorias.data; */
      
      //Si fuente_de_generacion es "Proveedor"
      if (data.fuente_de_generacion === "Proveedor") {
        //Realizaremos la consulta de los anexos del proveedor
        const responseanexo = await axios.get(
          process.env.REACT_APP_API_URL + "/maestros_ro/rx_proveedor_certificacion/" + data.idproveedor,
          {
            headers: {
              Authorization: "Bearer " + serviceAAD.getToken(),
            },
          }
        );
        let datanexos = responseanexo.data;
        //Llenamos el arreglo de anexos
        let tempanexo = datanexos.map(
          ({
            Tipo_Certificacion: tipo,
            Fecha_Vigencia: fecha_vigencia,
            Entidad_Aval: entidad,
          }) => ({
            tipo,
            fecha_vigencia,
            entidad,
          })
        );
        console.log('Arreglo de anexos: ', tempanexo)
        setDataAnexoEditar(tempanexo);
        }
      setValue("id", id);
      setValue("nombre", data.nombre);
      setValue("fuente_de_generacion", {
        value: data.fuente_de_generacion,
        label: data.fuente_de_generacion,
      });
      setValue("idproveedor",data.idproveedor);
      setValue("idaplicativo",data.idaplicativo);

      if (data.fuente_de_generacion === "Aplicativos") {
        setFuente(1);
      }
      if (data.fuente_de_generacion === "RPA") {
        setFuente(2);
      }
      if (data.fuente_de_generacion === "Proveedor") {
        setFuente(3);
      }
      if (data.fuente_de_generacion === "Otros") {
        setFuente(4);
      }

      if (data.fuente_de_generacion === "EUC") {
        setFuente(5);
      }

      setValue("nombre_de_fuente", data.nombre_de_fuente);
      setValue("ruta_generacion_ipe", data.ruta_generacion_ipe);

      setValue("clasificacion_ipe", {
        value: data.clasificacion_ipe,
        label: data.clasificacion_ipe,
      });
      setClasificacionIpe(data.clasificacion_ipe);

      setValue("realiza_filtro", {
        value: data.realiza_filtro,
        label: data.realiza_filtro,
      });
      setRealizaFiltro(data.realiza_filtro);

      setValue("filtros", data.filtros);
      setValue("existe_transformacion", {
        value: data.existe_transformacion,
        label: data.existe_transformacion,
      });
      setRealizaTransformacion(data.existe_transformacion);

      setValue("regenerar_ipe", {
        value: data.regenerar_ipe,
        label: data.regenerar_ipe,
      });
      setRegeneraIpe(data.regenerar_ipe);
      
      setEstadoIpe(data.estado === 1 ? {value: true, label:"Activo"} : {value: false, label:"Inactivo"})
      setValue("ruta_evidencia_ipe", data.ruta_evidencia_ipe);
      setcheckedA1(data.a1 === 1 ? true : false);
      setcheckedA2(data.a2 === 1 ? true : false);
      setcheckedA3(data.a3 === 1 ? true : false);
      setcheckedB(data.b === 1 ? true : false);
      setcheckedC(data.c === 1 ? true : false);
      setcheckedD(data.d === 1 ? true : false);
      setValue("otros_controles", data.otros_controles);
      setValue("responsable_ipe", {
        value: data.responsable_ipe_id,
        label: data.responsable_ipe, //cuando retorne el label desde el back, iria aqui el nombre
      });
      setValue("analista_sox", {
        value: data.analista_sox_id,
        label: data.analista_sox, //cuando retorne el label desde el back, iria aqui el nombre
      });
      setValue("compania", {
        value: data.compania,
        label: data.compania, //sucede lo mismo de responsable ipe
      });

      if (data.fuente_de_generacion == "Aplicativos") {
        let app = { nombre: data.nombre_de_fuente , idaplicativo: data.idaplicativo};
        setAplicativo(app);
      }

      let responseSegundaLinea = data.revision;

      let responseAtributos = data.atributos;
      let responsedataControles = data.controles;
      let responsedataControlesCheckbox = data.controles_asegura;

      let arrayAristas = data?.aristas.split(",");
      let aristasEdit = [];
      arrayAristas.forEach((string) => {
        aristasEdit.push({ value: string, label: string });
      });
      setStrAristas(aristasEdit);
      console.log("aristas Edit", aristasEdit);
      setValue("aristas", aristasEdit);
      // responseSegundaLinea.map((datSeg) => {
      //   let tempRG = datSeg.revision.split(";");
      //   let tempList = tempRG.map((rg) => ({ label: rg, value: rg }));

      //   datSeg["user"] = datSeg.usuario_creador.split("@")[0];
      //   datSeg["riesgosGestionadosList"] = tempList;
      //   datSeg["unidad"] = {
      //     nombre: datSeg.nombre_unidad_riesgo,
      //     id: datSeg.id_unidad_riesgo,
      //   };
      // });
      setDataRevision(responseSegundaLinea);
      setDataAtributos(responseAtributos);
      setDataControles(responsedataControles);
      setDataControlesCheckbox(responsedataControlesCheckbox);
      camposDinamicos();
      setLoadingData(false);
    } catch (error) {}
  };

  useEffect(() => {
    setLoadingData(true);
    // console.log(localStorage)
    console.log("location.state.idipe",location.state.idipe)
    const GetUsuariosResponsable = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL + "/usuariosrol/0/3",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + serviceAAD.getToken(),
          },
        }
      );

      let data = await result.json();

      let temp = data.map(({ idposicion: value, nombre: label }) => ({
        value,
        label,
      }));

      setDataResponsable(temp);
    };

    const GetUsuariosAnalistas = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL + "/usuariosrol/0/4",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + serviceAAD.getToken(),
          },
        }
      );

      let data = await result.json();

      let temp = data.map(({ idposicion: value, nombre: label }) => ({
        value,
        label,
      }));

      setDataAnalistaSox(temp);
    };

    const GetCompanias = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL + "/maestros_ro/compania/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + serviceAAD.getToken(),
          },
        }
      );

      let data = await result.json();

      let temp = data.map(({ idcompania: value, compania: label }) => ({
        value,
        label,
      }));

      setDataCompanias(temp);
    };

    const GetIpesClasi = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL + "/generales/Ipes/Clasificacion/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + serviceAAD.getToken(),
          },
        }
      );

      let data = await result.json();

      let temp = data.map(({ idm_parametrosgenerales: value, valor: label }) => ({
        value,
        label,
      }));

      setDataIpesClasi(temp);
    };

    async function getControles() {
      try {
        setLoadingDataAtributos(true);
        const result = await fetch(
          process.env.REACT_APP_API_URL + "/controles/",
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + serviceAAD.getToken(),
            },
          }
        );
        let controles = await result.json();
        dataControlesAtributo = controles;
        setLoadingDataAtributos(false);
      } catch (error) {
        console.error(error);
      }
    }

    const GetArea = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL + "/maestros_ro/area_o/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + serviceAAD.getToken(),
          },
        }
      );

      let data = await result.json();

      let areas = data.map(({ idarea_organizacional, nombre }) => ({
        value: idarea_organizacional,
        label: nombre,
      }));
      setDataArea(areas);
    };

    const GetProceso = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL + "/ultimonivel/Proceso",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + serviceAAD.getToken(),
          },
        }
      );

      let data = await result.json();

      let areas = data.map(({ id, nombre }) => ({
        value: id,
        label: nombre,
      }));
      setDataProceso(areas);
    };
    
    if (!consultasBool) {
      GetUsuariosResponsable();
      GetUsuariosAnalistas();
      GetCompanias();
      getControles();
      GetIpesClasi();
      GetArea();
      GetProceso();
      // llenarFormulario(34);
      if (typeof location.state != "undefined") {
        if (location.state.idipe) {
          let id = location.state.idipe;
          setID(id);
          setValue("idipe", id);
          llenarFormulario(id);
        }
      } else {
        alert("Ups, ocurrió un error, trata de recargar la página");
      }
      setConsultasBool(true);
    }

    if (paSelected) {
      console.log(paSelected);
      let tempDataRevision = dataRevision;
      if (paSelected && paSelected[0] && !paSelected[0].idplanaccion) {
        tempDataRevision[indexPA]["idPAs"] = paSelected.join(",");
      } else {
      }
      setDataRevision(tempDataRevision);
    }

    if (controlSelected) {
      let tempDataAtributos = dataAtributos;
      console.log("controlSelected",controlSelected);
      if (
        controlSelected &&
        controlSelected[0] &&
        !controlSelected[0].idcontrol
      ) {
        console.log(tempDataAtributos[indexControl]);

        tempDataAtributos[indexControl]["idControles"] = controlSelected.join(",");
        console.log(tempDataAtributos[indexControl]);
      } else {
      }

      setDataAtributos(tempDataAtributos);
      setControlSelected(null);
    }
    setLoadingData(false);
    async function getAristas() {
      let requestAristas = await Queries(null, "/maestros_ro/aristas/", "GET");
      requestAristas = requestAristas.map(({ nombre }) => ({
        value: nombre,
        label: nombre,
      }));
      setListaAristas(requestAristas);
    }
    getAristas();
  }, [paSelected, controlSelected]);

  const GetAnexoProveedor = async (id) => {
    const result = await fetch(
      process.env.REACT_APP_API_URL +
        "/maestros_ro/rx_proveedor_certificacion/" +
        id,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + serviceAAD.getToken(),
        },
      }
    );

    let data = await result.json();

    let temp = data.map(
      ({
        Tipo_Certificacion: tipo,
        Fecha_Vigencia: fecha_vigencia,
        Entidad_Aval: entidad,
      }) => ({
        tipo,
        fecha_vigencia,
        entidad,
      })
    );
    setDataAnexo(temp);
  };

  // const cargarApps = async () => {
  //   if (!aplicaciones.dataTable) {
  //     const response = await axios.get(
  //       "https://grc-rotic-alb.apps.bancolombia.com/activosCodGen/1/COM/",
  //       {
  //         headers: {},
  //       }
  //     );
  //     let dataPrin = response.data.filter((o) => o.componente_principal);
  //     let tempJsonOpciones = {
  //       dataTable: dataPrin,
  //       nameCol: ["ID Activo", "Nombre", "Descripción"],
  //       nameRow: ["idactivo", "nombre", "descripcion"],
  //       nameId: "idactivo",
  //       busqueda: true,
  //       nameBusqueda: ["idactivo", "nombre", "descripcion"],
  //     };
  //     setAplicaciones(tempJsonOpciones);
  //   }
  // };

  const cargarApps = async () => {
    if (!aplicaciones.dataTable) {
      const response = await axios.get(
        process.env.REACT_APP_API_URL + "/aplicativosget/0/",
        {
          headers: {},
        }
      );
      let dataPrin = response.data.filter((o) => o.componente_principal);
      let tempJsonOpciones = {
        dataTable: dataPrin,
        nameCol: ["ID Activo", "Nombre", "Descripción", "Compañia"],
        nameRow: ["idaplicativo", "nombre", "descripcion", "compania"],
        nameId: "idaplicativo",
        busqueda: true,
        nameBusqueda: ["idaplicativo", "nombre", "descripcion", "compania"],
      };

      setAplicaciones(tempJsonOpciones);
    }
  };

  const handleOnAdd = () => {
    // controles = controles.concat(idControlesAtributo);
    setRows(rows.concat(defaultState));
  };

  const handleOnChange = (index, name, value) => {
    //Almacenar en un arreglo con la siguiente estructura
    //[{"nombre_atributo":nombre_atributo,"estado":estado,"fuente_atributo":fuente_atributo,"proceso_captura":proceso_captura}]
    controles.push(idControlesAtributo);
    let otros_controles_atributos = document.getElementById(
      "otros_controles_atributos"
    ).value;
    let temp = [...rows];
    temp[index] = {
      ...temp[index],
      [name]: value,
      controles,
      otros_controles_atributos,
    };
    setRows(temp);
  };

  const handleOnRemove = (index) => {
    rows.splice(index, 0);
  };

  const addRowRevision = async (e) => {
    try {
      const usr = serviceAAD.getUser().userName.split("@")[0];

      let requestUnidad = await Queries(
        "null",
        "/rxunidad_analista/" + localStorage.getItem("idposicion") + "/",
        "GET"
      );
      let rowsRevisionTemp = dataRevision;
      rowsRevisionTemp.push({
        id: rowsRevisionTemp.length + 1,
        user: usr,
        unidad: {
          id: requestUnidad[0].idunidad_riesgo.idunidad_riesgo,
          nombre: requestUnidad[0].idunidad_riesgo.nombre,
        },
      });

      setDataRevision(rowsRevisionTemp);
      setDataRevisionBool(!dataRevisionBool);
    } catch (error) {
      console.error(error);
    }
  };

  const addRowAtributos = async (e) => {
    try {
      const usr = serviceAAD.getUser().userName.split("@")[0];

      let requestUnidad = await Queries(
        "null",
        "/rxunidad_analista/" + localStorage.getItem("idposicion") + "/",
        "GET"
      );
      let rowsRevisionTemp = dataAtributos;
      rowsRevisionTemp.push({
        id: rowsRevisionTemp.length + 1,
        user: usr,
        unidad: {
          id: requestUnidad[0].idunidad_riesgo.idunidad_riesgo,
          nombre: requestUnidad[0].idunidad_riesgo.nombre,
        },
      });

      setDataAtributos(rowsRevisionTemp);
      setDataAtributosBool(!dataAtributosBool);
    } catch (error) {
      console.error(error);
    }
  };

  const openPAModal = async (data, index) => {
    let requestPA = await Queries(null, "/planesdeAccion/", "GET");
    let tempJsonOpciones = {
      dataTable: requestPA,
      nameCol: [
        "ID Plan Acción",
        "Nombre",
        "Descripción",
        "Responsable",
        "Analista",
        "Estado",
      ],
      nameRow: [
        "idplanaccion",
        "nombre",
        "descripcionpa",
        "responsablepa",
        "analistariesgos",
        "estadopa",
      ],
      nameId: "idplanaccion",
      busqueda: true,
      nameBusqueda: [
        "idplanaccion",
        "nombre",
        "descripcionpa",
        "responsablepa",
        "analistariesgos",
        "estadopa",
      ],
    };
    setDataTablePAs(tempJsonOpciones);
    if (data.idPAs) {
      let tempSelected = data.idPAs.split(",");
      tempSelected = tempSelected.map((pa) => ({ idplanaccion: parseInt(pa) }));
      setPaSelected(tempSelected);
    } else {
      setPaSelected(null);
    }

    setIndexPA(index);
    setShowPAs(true);
  };
  const openControlsModal = async (data, index) => {
    let requestControles = await Queries(null, "/controles/", "GET");
    let tempJsonOpciones = {
      dataTable: requestControles,
      nameCol: ["ID", "Nombre control"],
      nameRow: ["idcontrol", "nombre"],
      nameId: "idcontrol",
      busqueda: true,
      nameBusqueda: ["idcontrol", "nombre"],
    };

    setDataTableControl(tempJsonOpciones);
    if (data.idControles) {
      let tempSelected = data.idControles.split(",");
      tempSelected = tempSelected.map((co) => ({ idcontrol: parseInt(co) }));
      setControlSelected(tempSelected);
    } else {
      setControlSelected(null);
    }

    setIndexControl(index);
    setShowControls(true);
  };

  const onSubmit = (data) => {
    let arrayControles = [];
    //datacontroles viene vacio no hace el .push debe ser dataControlesAtributo
    dataControles.forEach((obj) => arrayControles.push(obj.idcontrol));
    let arrayControlesCheckbox = [];
    dataControlesCheckbox.forEach((obj) => arrayControlesCheckbox.push(obj.idcontrol));
    
    if(dataAtributos){
    let stringAristas = strAristas.map((obj) => obj.label).join(",");

    var checkeddist;
    if (data.fuente_de_generacion.label === "Proveedor"){
      checkeddist = true
    }

    console.log(aplicativo);

    if ((((fuente === 4 && clasificacionIpe === "Documentos Externos" && realizaFiltro === "No Aplica" && realizaTransformacion === "No Aplica" && regeneraIpe === "No Aplica"))|| (fuente === 1 && clasificacionIpe === "Documentos Externos" && realizaFiltro === "No Aplica" && realizaTransformacion === "No Aplica" && regeneraIpe === "No Aplica"))) {
      checkeddist = true
    }
    
    if ((((fuente === 5 && clasificacionIpe === "Output de EUC" && realizaFiltro === "No" && realizaTransformacion === "No" && regeneraIpe === "Si") || (fuente === 5 && clasificacionIpe === "Output de EUC" && realizaFiltro === "No" && realizaTransformacion === "No" && regeneraIpe === "No"))|| (fuente === 5 && clasificacionIpe === "Output de EUC" && realizaFiltro === "Si" && realizaTransformacion === "No" && regeneraIpe === "Si"))) {
      checkeddist = true
    }

    if ((((((((fuente === 1 && clasificacionIpe === "Estándar/Customizado" && realizaFiltro === "No" && realizaTransformacion === "No" && regeneraIpe === "Si")) || (fuente === 1 && clasificacionIpe === "Estándar/Customizado" && realizaFiltro === "Si" && realizaTransformacion === "No" && regeneraIpe === "Si")) || (fuente === 1 && clasificacionIpe === "Estándar/Customizado" && realizaFiltro === "No" && realizaTransformacion === "No" && regeneraIpe === "No")) || (fuente === 1 && clasificacionIpe === "Query Tecnología" && realizaFiltro === "No" && realizaTransformacion === "No" && regeneraIpe === "Si")) || (fuente === 1 && clasificacionIpe === "Query Tecnología" && realizaFiltro === "Si" && realizaTransformacion === "No" && regeneraIpe === "Si")) || (fuente === 1 && clasificacionIpe === "Query Tecnología" && realizaFiltro === "No" && realizaTransformacion === "No" && regeneraIpe === "No"))) {
      checkeddist = true
    }

    if (
      checkedA1 ||
      checkedA2 ||
      checkedA3 ||
      checkedB ||
      checkedC ||
      checkedD ||
      checkeddist ||
      otrosControles
    ) {
      var datosEnviar = {
        //Causas, datos generales (POST)
        nombre: data.nombre ? data.nombre : null,
        compania: data.compania ? data.compania.label : null,
        responsable_ipe: 0,
        analista_sox: data.analista_sox.value
          ? data.analista_sox.value
          : null,
        fuente_de_generacion: data.fuente_de_generacion.label
          ? data.fuente_de_generacion.label
          : null,
          nombre_de_fuente: data.fuente_de_generacion.label === "Proveedor" ? data.idproveedor  :  data.fuente_de_generacion.label === "Aplicativos" ? aplicativo.idaplicativo : data.nombre_de_fuente,
        ruta_generacion_ipe: data.ruta_generacion_ipe
          ? data.ruta_generacion_ipe
          : null,
        clasificacion_ipe: data.clasificacion_ipe.label
          ? data.clasificacion_ipe.label
          : null,
        realiza_filtro: data.realiza_filtro.value
          ? data.realiza_filtro.value
          : null,
        filtros: data.filtros ? data.filtros : null,
        existe_transformacion: data.existe_transformacion.value
          ? data.existe_transformacion.value
          : null,
        regenerar_ipe: data.regenerar_ipe.value
          ? data.regenerar_ipe.value
          : null,
        ruta_evidencia_ipe: data.ruta_evidencia_ipe
          ? data.ruta_evidencia_ipe
          : null,
        controles: dataControles ? arrayControles : null,
        a1: checkedA1 ? 1 : 0,
        a2: checkedA2 ? 1 : 0,
        a3: checkedA3 ? 1 : 0,
        b: checkedB ? 1 : 0,
        c: checkedC ? 1 : 0,
        d: checkedD ? 1 : 0,
        itgc: itgc ? 1 : 0,
        otros_controles: otrosControles ? otrosControles : null,
        controles_asegura: dataControlesCheckbox ? arrayControlesCheckbox : null,
        atributos: dataAtributos ? dataAtributos : null,
        revision: dataRevision ? dataRevision : null,
        aristas: strAristas ? stringAristas : null,
        estado: estadoipe ? (estadoipe.value === true ? 1 : 0) : null
      };
      
      if (arrayControles.length == 0) {
        setEstadoPost({
          id: 3,
          data: "Debe asociar al menos un control donde se utiliza la IPE",
        });
        setTimeout(() => {
          setEstadoPost({ id: 0, data: null });
        }, 10000);
      } 
      else if (strAristas.length === 0)
      {
        setEstadoPost({
          id: 3,
          data: "Debe llenar el campo aristas del riesgo",
        });
        setTimeout(() => {
          setEstadoPost({ id: 0, data: null });
        }, 10000);
      }
      else {
        try {
          axios
            .put(
              process.env.REACT_APP_API_URL + "/ipes/" + idIpe,
              datosEnviar,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + serviceAAD.getToken(),
                },
              }
            )
            .then(function (response) {
              if (response.status >= 200 && response.status < 300) {
                setEstadoPost({ id: 2, data: "Guardado con éxito" });
                setTimeout(() => {
                  setEstadoPost({ id: 0, data: null });
                }, 10000);

                /*               history.push({
                      pathname: "/EditarIpe",
                      state: { id: response.data.idipe },
                    }); */
              } else if (response.status >= 300 && response.status < 400) {
                setEstadoPost({
                  id: 4,
                  data: "Error al guardar la información",
                });
                setTimeout(() => {
                  setEstadoPost({ id: 0, data: null });
                }, 10000);
              } else if (response.status >= 400 && response.status < 512) {
                setEstadoPost(5, "Error");
                setTimeout(() => {
                  setEstadoPost({ id: 0, data: null });
                }, 10000);
              }
            })
            .catch((errors) => {
              setEstadoPost({ id: 3, data: "Error al guardar: " + JSON.stringify(errors.response.data) });
              setTimeout(() => {
                setEstadoPost({ id: 0, data: null });
              }, 10000);
            });
        } catch (error) {
          console.error(error);
        }
      }
     } 
    //  else {
    //   setEstadoPost({
    //     id: 3,
    //     data: "Debe seleccionar al menos un control para asegurar la construcción de la IPE",
    //   });
    //   setTimeout(() => {
    //     setEstadoPost({ id: 0, data: null });
    //   }, 10000);
      
    // }
  }
  else{
    setEstadoPost({
      id: 3,
      data: "Debe diligenciar la tabla de atributos de la ipe",
    });
    setTimeout(() => {
      setEstadoPost({ id: 0, data: null });
    }, 10000);
  }
  };

  const onError = (errors) => console.log(errors);

  const handleChange = (event) => {
    if(event === "NADA") {
      setSelectedValue(null);
      setcheckedA1(false);
      setcheckedA2(false);
      setcheckedA3(false);
      setcheckedB(false);
      setcheckedC(false);
      setcheckedD(false);
      setItgc(false);
    }
    else {
    setSelectedValue(event.target.value);
    if (event.target.value == "A1") {
      setcheckedA1(true);
      setcheckedA2(false);
      setcheckedA3(false);
      setcheckedB(false);
      setcheckedC(false);
      setcheckedD(false);
      setItgc(false);
    } else if (event.target.value == "A2") {
      setcheckedA1(false);
      setcheckedA2(true);
      setcheckedA3(false);
      setcheckedB(false);
      setcheckedC(false);
      setcheckedD(false);
      setItgc(false);
    } else if (event.target.value == "A3") {
      setcheckedA1(false);
      setcheckedA2(false);
      setcheckedA3(true);
      setcheckedB(false);
      setcheckedC(false);
      setcheckedD(false);
      setItgc(false);
    } else if (event.target.value == "B") {
      setcheckedA1(false);
      setcheckedA2(false);
      setcheckedA3(false);
      setcheckedB(true);
      setcheckedC(false);
      setcheckedD(false);
      setItgc(false);
    } else if (event.target.value == "C") {
      setcheckedA1(false);
      setcheckedA2(false);
      setcheckedA3(false);
      setcheckedB(false);
      setcheckedC(true);
      setcheckedD(false);
      setItgc(false);
    } else if (event.target.value == "D") {
      setcheckedA1(false);
      setcheckedA2(false);
      setcheckedA3(false);
      setcheckedB(false);
      setcheckedC(false);
      setcheckedD(true);
      setItgc(false);
    }
    else {
      setcheckedA1(false);
      setcheckedA2(false);
      setcheckedA3(false);
      setcheckedB(false);
      setcheckedC(false);
      setcheckedD(false);
      setItgc(false);
    }
  }
  };

  const DesasociarControl = () => {
    if (selectedControles[0]) {
      const selectedData = dataControles.filter(
        (control) => control.idcontrol !== selectedControles[0]
      );
      setDataControles(selectedData);
      selectedControles([]);
    } else {
    }
  };
  const DesasociarControlCheckbox = () => {
    if (selectedControles[0]) {
      const selectedData = dataControlesCheckbox.filter(
        (control) => control.idcontrol !== selectedControles[0]
      );
      setDataControlesCheckbox(selectedData);
      selectedControles([]);
    } else {
    }
  };

  // const DesasociarControlAtributos = () => {
  //   if (selectedControles[0]) {
  //     const selectedData = dataControlesAtributos.filter(
  //       (control) => control.idcontrol !== selectedControles[0]
  //     );
  //     setDataControlesAtributos(selectedData);
  //     selectedControles([]);
  //   } else {
  //   }
  // };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat([], name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  return (
    <>
    {!dataCompanias ? (
      
      <Row className="mb-3 mt-5">
        <Col>
          <Loader
            type="Oval"
            color="#FFBF00"
            style={{ textAlign: "center", position: "static" }}
          />
        </Col>
      </Row>
      
        ) : (

        
    <>
      <AlertDismissibleExample alerta={estadoPost} />
      <Container fluid>
        <FormProvider {...methods}>
          <ModalSelectTableCustom
            showMod={showPAs}
            setShowMod={setShowPAs}
            data={paSelected}
            setData={setPaSelected}
            dataTable={dataTablePAs}
            multi={true}
          />
          <ModalSelectTableCustom
            showMod={showControls}
            setShowMod={setShowControls}
            data={controlSelected}
            setData={setControlSelected}
            dataTable={dataTableControl}
            multi={true}
          />
          <ModalAsociarProveedor
            show={showModalAsociarProveedor}
            onHide={() => setShowModalAsociarProveedor(false)}
            dataProveedor={dataProveedor}
            setDataProveedor={setDataProveedor}
            GetAnexoProveedor={GetAnexoProveedor}
          />
          <ModalAsociarControl
            show={showAsociarControles}
            onHide={() => setShowAsociarControles(false)}
            dataControles={dataControles}
            dataControlesCheckbox={dataControlesCheckbox}
            compania={compania}
            setDataControles={setDataControles}
            setDataControlesCheckbox = {setDataControlesCheckbox}
            flagAsegura={flagAsegura}
            flagControla={flagControla}
            setFlagAsegura={setFlagAsegura}
            setFlagControla={setFlagControla}
          />

          <ModalSelectTableCustom
            showMod={showModApps}
            setShowMod={setShowModApps}
            data={aplicativo}
            setData={setAplicativo}
            dataTable={aplicaciones}
            multi={false}
          />
          

          <Row className="mb-3 mt-3">
            <Col sm={8} xs={12}>
              <h1 className="titulo">Editar Ipe</h1>
            </Col>

            <Col sm={2} xs={12}>
              <Link to="Ipes">
                <Button type="button" className="botonNegativo">
                  Cancelar
                </Button>
              </Link>
            </Col>
           
            <Col sm={2} xs={12}>
            {props.permisos.editar ? (
              <Button
                type="submit"
                onClick={handleSubmit(onSubmit, onError)}
                variant={"contained"}
                className="btn botonPositivo"
                >
                Guardar
              </Button>
              ) : null}
            </Col>
          </Row>

             <Row className="mb-4">
            <Col sm={2} xs={12}>
              <label className="forn-label label">ID de IPE</label>
            </Col>
            <Col sm={4} xs={12}>
              <input
                value={idIpe ? idIpe : null}
                type="text"
                className="form-control text-center texto"
                placeholder="Nombre IPE"
                disabled={true}
              />
            </Col>
          </Row>                

          <Row className="mb-4">
            <Col sm={2} xs={12}>
              <label className="forn-label label">Nombre IPE*</label>
            </Col>
            <Col sm={4} xs={12}>
              <input
                {...register("nombre", {
                  required: "Te faltó completar este campo",
                })}
                type="text"
                className="form-control text-center texto"
                placeholder="Nombre IPE"
              />
              <p className="text-center">{errors.nombre?.message}</p>
            </Col>
            <Col sm={2} xs={12}>
              <label className="forn-label label">Compañia</label>
            </Col>
            <Col sm={4} xs={12}>
              <Controller
                control={control}
                name="compania"
                rules={{
                  required: "Te faltó completar este campo",
                }}
                render={({ field }) => (
                  <Select
                    components={animatedComponents}
                    options={dataCompanias}
                    onChange={(e) => {
                      field.onChange(e);
                      setCompania(e);
                    }}
                    value={field.value}
                    placeholder="Seleccione la compañia"
                  />
                )}
              />
              <p className="text-center">{errors.compania?.message}</p>
            </Col>
          </Row>
          <Row className="mb-4">
          <Col sm={2} xs={12}>
              <label className="forn-label label">Estado</label>
            </Col>
          <Col sm={2} xs={12}>
              <>
                <Switch
                  checked={estadoipe ? estadoipe.value : null}
                  onChange={(e) => {                 
                    let label = e.target.checked === true ? "Activo" : "Inactivo";
                  setEstadoIpe({
                    value: e.target.checked,
                    label: label,
                  });}}
                ></Switch>
                <label className="form-label text">
                  {estadoipe ? estadoipe.label : null}
                </label>
              </>
          </Col>

          </Row>
          {/* <Row className="mb-4"> */}
            {/* <Col sm={2} xs={12}>
              <label className="forn-label label">Responsable IPE*</label>
            </Col>
            <Col sm={4} xs={12}>
              <Controller
                control={control}
                name="responsable_ipe"
                rules={{
                  required: "Te faltó completar este campo",
                }}
                render={({ field }) => (
                  <Select
                    components={animatedComponents}
                    options={dataResponsable}
                    onChange={field.onChange}
                    value={field.value}
                    placeholder="Seleccione el Responsable IPE"
                  />
                )}
              />
              <p className="text-center">{errors.responsable_ipe?.message}</p>
            </Col> */}
            {/* <Col sm={2} xs={12}>
              <label className="forn-label label">Analista SOX*</label>
            </Col>
            <Col sm={4} xs={12}>
              <Controller
                control={control}
                name="analista_sox"
                rules={{
                  required: "Te faltó completar este campo",
                }}
                render={({ field }) => (
                  <Select
                    components={animatedComponents}
                    options={dataAnalistaSox}
                    onChange={field.onChange}
                    value={field.value}
                    placeholder="Seleccione el Analista SOX"
                  />
                )}
              />
              <p className="text-center">{errors.analista_sox?.message}</p>
            </Col>
          </Row> */}
          <Row className="mb-4">
            <Col sm={2} xs={12}>
              <label className="forn-label label">Fuente de generación*</label>
            </Col>
            <Col sm={3} xs={12}>
              <Controller
                //is a prop that we get back from the useForm Hook and pass into the input.
                control={control}
                //is how React Hook Form tracks the value of an input internally.
                name={"fuente_de_generacion"}
                //render is the most important prop; we pass a render function here.
                render={({
                  //The function has three keys: field , fieldState, and formState.
                  field: { onChange, value }, // The field object exports two things (among others): value and onChange
                  fieldState: { errors },
                  formState,
                }) => (
                  <>
                    <Select
                      components={animatedComponents}
                      options={[
                        { value: 1, label: "Aplicativos" },
                        { value: 2, label: "RPA" },
                        { value: 3, label: "Proveedor" },
                        { value: 4, label: "Otros" },
                        { value: 5, label: "EUC" },
                      ]}
                      onChange={(e) => {
                        onChange(e);
                        setFuente(e.value);
                        handleChange("NADA");
                        camposDinamicos();
                      }}
                      value={value}
                      placeholder={"Seleccione la fuente de generación"}
                    />
                  </>
                )}
                rules={{
                  required: "Te faltó completar este campo",
                }}
              />
              <p className="text-center">
                {errors.fuente_de_generacion?.message}
              </p>
            </Col>
            <Col sm={2} xs={12}>
              <label className="forn-label label">Nombre de la fuente*</label>
            </Col>
            <Col sm={5} xs={12}>
              {/* En casos 2 y 4 un input
                    En caso 1 traer maestro de aplicativos API de Roti(FALTAAAA)
                    En caso 3 un botón/label para agregar un proveedor(INCOMPLETO)  */}
              {fuente == 1 ? (
                <Row className="mb-3">
                  <Col sm={4} xs={12}>
                    <label className="forn-label label">Aplicativo</label>
                  </Col>
                  <Col sm={6} xs={10}>
                    <input
                      type="text"
                      disabled
                      value={
                        aplicativo && aplicativo.nombre
                          ? aplicativo.nombre
                          : null
                      }
                      className="form-control text-center texto"
                      placeholder="Seleccione Aplicativo"
                      id="App"
                    ></input>
                  </Col>
                  <Col sm={2} xs={10}>
                    <button
                      type="button"
                      className="btn botonPositivo"
                      onClick={async () => {
                        await cargarApps();
                        setShowModApps(true);
                      }}
                    >
                      Seleccionar
                    </button>
                  </Col>
                </Row>
              ) : null}
              {(fuente == 2) | (fuente == 4) | (fuente == 5) ? ( 
                <input
                  {...register("nombre_de_fuente", {
                    required: "Te faltó completar este campo",
                  })}
                  type="text"
                  className="form-control text-center texto"
                  placeholder="Nombre fuente"
                />
              ) : null}
              {fuente == 3 ? (
                //Invocar al modal de proveedores
                <Row>
                  <Button
                    type="button"
                    onClick={() => {
                      setShowModalAsociarProveedor(true);
                      setDataAnexoEditar(null);
                    }}
                    variant={"contained"}
                    className="btn botonPositivo"
                  >
                    Agregar
                  </Button>
                  <Col>
                    <input
                      type="text"
                      disabled={true}
                      className="form-control text-left texto"
                      placeholder={"Proveedor"}
                      {...register("nombre_de_fuente", {
                        required: "Te faltó completar este campo",
                      })}
                    ></input>
                  </Col>
                </Row>
              ) : //FALTAN COSITAS EN ESTA PARTE
              null}
              <p className="text-center">{errors.nombre_de_fuente?.message}</p>
            </Col>
          </Row>
          <Row className="mb-4">
            <Col sm={3} xs={12}>
              <label className="forn-label label">
                Opción/Transacción/Ruta por la cual se genera la IPE*
              </label>
            </Col>
            <Col sm={9} xs={12}>
              <input
                {...register("ruta_generacion_ipe", {
                  required: "Te faltó completar este campo",
                })}
                type="text"
                className="form-control text-center texto"
                placeholder="Ruta generación IPE"
              />
              <p className="text-center">
                {errors.ruta_generacion_ipe?.message}
              </p>
            </Col>
          </Row>

          <Row className="mb-4">
            <Col sm={2} xs={12}>
              <label className="forn-label label">
                Clasificación de la IPE*
              </label>
            </Col>
            <Col sm={3} xs={12}>
              <Controller
                control={control}
                name={"clasificacion_ipe"}
                render={({
                  field: { onChange, value },
                  fieldState: { errors },
                  formState,
                }) => (
                  <>
                    <Select
                      components={animatedComponents}
                      options={dataIpesClasi}
                      onChange={(e) => {
                        onChange(e);
                        setClasificacionIpe(e.label);
                        handleChange("NADA");
                      }}
                      value={value}
                      placeholder={"Seleccione la clasificación de la IPE"}
                    />
                  </>
                )}
                rules={{
                  required: "Te faltó completar este campo",
                }}
              />
              <p className="text-center">{errors.clasificacion_ipe?.message}</p>
            </Col>
          </Row>
          <Row className="mb-4">
            <Col sm={2} xs={12}>
              <label className="forn-label label">Se realiza Filtro?*</label>
            </Col>
            <Col sm={3} xs={12}>
              <FormSearchListSiNoNa
                name="realiza_filtro"
                control={control}
                set={setRealizaFiltro}
                handleChange = {handleChange}
              />
              <p className="text-center">{errors.realiza_filtro?.message}</p>
            </Col>
          </Row>
          
          {realizaFiltro == "Si" ? (
            <Row className="mb-4">
              <Col sm={2} xs={12}>
                <label className="forn-label label">
                  Cuáles son los filtros?
                </label>
              </Col>
              <Col sm={8} xs={12}>
                <input
                  {...register("filtros")}
                  type="text"
                  className="form-control text-center texto"
                  placeholder="Filtros"
                />
                <p className="text-center">{errors.filtros?.message}</p>
              </Col>
            </Row>
          ) : null}
          <Row className="mb-4">
            <Col sm={2} xs={12}>
              <label className="forn-label label">
                Existe transformación?*
              </label>
            </Col>
            <Col sm={3} xs={12}>
              <FormSearchListSiNoNa
                name="existe_transformacion"
                control={control}
                /* pasar un set vacio */
                set={setRealizaTransformacion}
                handleChange = {handleChange}
              />
              <p className="text-center">
                {errors.existe_transformacion?.message}
              </p>
            </Col>
            <Col sm={7} xs={12}>
              <p className="text-center">
                {
                  "Ayuda: También se debe colocar “Si” en caso de que se cambie el formato de la información (por ejemplo si se cambia de *.xlsx a *.txt)"
                }
              </p>
            </Col>
          </Row>
          <Row className="mb-4">
            <Col sm={2} xs={12}>
              <label className="forn-label label">
                Puede regenerar la IPE cuando se requiera?*
              </label>
            </Col>
            <Col sm={3} xs={12}>
              <FormSearchListSiNoNa
                name="regenerar_ipe"
                control={control}
                set={setRegeneraIpe}
                handleChange = {handleChange}
              />
              <p className="text-center">{errors.regenerar_ipe?.message}</p>
            </Col>
          </Row>
          <Row className="mb-4">
            <Col sm={2} xs={12}>
              <label className="forn-label label">
                Ruta donde se almacena evidencia de la IPE
              </label>
            </Col>
            <Col sm={10} xs={12}>
              <input
                {...register("ruta_evidencia_ipe")}
                type="text"
                className="form-control text-center texto"
                placeholder="Ruta evidencia IPE"
              />
              <p className="text-center">
                {errors.ruta_evidencia_ipe?.message}
              </p>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col sm={2} xs={12}>
              <label className="form-label label">Aristas del riesgo*​</label>
            </Col>
            <Col sm={3} xs={12}>
              <Controller
                control={control}
                name="aristas"
                rules={{ required: "Te faltó completar este campo" }}
                render={({ field }) => (
                  <Select
                    options={listaAristas}
                    isMulti
                    components={animatedComponents}
                    value={field.value}
                    id="aristas"
                    onChange={(e) => {
                      const fiteredProgramas = new Set();
                      const newArray = e.filter((element) => {
                        const isDuplicate = fiteredProgramas.has(
                          element.label
                        );
                        fiteredProgramas.add(element.label);
                        if (!isDuplicate) {
                          return true;
                        } else {
                          return false;
                        }
                      });
                      console.log("newArray", newArray);
                      setStrAristas(newArray);
                      field.onChange(newArray);
                    }}
                  />
                )}
              />
              <p className="text-center">{errors.aristas?.message}</p>
            </Col>
          </Row>
          <hr />
          <br />
          <Row className="mb-3">
            <Col sm={6} xs={12}>
              <label className="form-label label">
                Controles donde se utiliza la IPE
              </label>
            </Col>

            <Col sm={2} xs={12}>
              <button
                type="button"
                className="btn botonPositivo"
                onClick={() => {
                  setShowAsociarControles(true);
                  setFlagControla(true);
                }}
              >
                Asociar
              </button>
            </Col>
            <Col sm={2} xs={12}>
              <button
                type="button"
                className="btn botonNegativo"
                onClick={DesasociarControl}
              >
                Desasociar
              </button>
            </Col>
          </Row>
          <Row className="mb-4">
            <Paper className={classes.root}>
              <TableContainer component={Paper} className={classes.container}>
                <Table
                  className={"text"}                  
                  aria-label="sticky table"
                >
                  {/* Inicio de encabezado */}
                  <TableHead className="titulo">
                    <TableRow>
                      <StyledTableCell padding="checkbox"></StyledTableCell>

                      <StyledTableCell align="left">ID Control</StyledTableCell>

                      <StyledTableCell align="left">Control</StyledTableCell>

                      <StyledTableCell align="left">Proceso</StyledTableCell>

                      <StyledTableCell align="left">Estado</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  {/* Fin de encabezado */}
                  {/* Inicio de cuerpo de la tabla */}
                  <TableBody>
                    {dataControles.map((row, index) => {
                      const isItemSelected = isSelectedControles(row.idcontrol);
                      return (
                        <StyledTableRow
                          key={row.idcontrol}
                          hover
                          onClick={(event) =>
                            handleClickControles(event, row.idcontrol)
                          }
                          selected={isItemSelected}
                          role="checkbox"
                          tabIndex={-1}
                        >
                          <StyledTableCell component="th" scope="row">
                            <Checkbox checked={isItemSelected} />
                          </StyledTableCell>

                          <StyledTableCell component="th" scope="row">
                            {row.idcontrol ? row.idcontrol : null}
                          </StyledTableCell>

                          <StyledTableCell align="left">
                            {row.nombre ? row.nombre : null}
                          </StyledTableCell>

                          <StyledTableCell align="left">
                            {row.proceso ? row.proceso : null}
                          </StyledTableCell>

                          <StyledTableCell align="left">
                            {row.estado ? row.estado : null}
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    })}
                  </TableBody>
                  {/* Fin de cuerpo de la tabla */}
                </Table>
              </TableContainer>
            </Paper>
          </Row>
          <Row className="mb-4">
            <Col sm={12} xs={12}>
              <hr />
              <label className="form-label label">
                Controles para asegurar la generación de la IPE
              </label>
            </Col>
            <Col sm={12} xs={12}>
              <span>
                Indica cuáles de los siguientes controles tienes para proteger
                la generación de tu IPE:
              </span>
            </Col>
          </Row>
          {/* Si realiza_filtro es Sí y regeneraIpe es No, mostrar el siguiente Row*/}

          {
            ((((((((fuente === 4 && clasificacionIpe === "Query Usuario" && realizaFiltro === "Si" && regeneraIpe === "Si" && realizaTransformacion === "No") || fuente === 1 && clasificacionIpe === "Estándar/Customizado" && realizaFiltro === "Si" && regeneraIpe === "No" && realizaTransformacion === "No") || (fuente === 5 && clasificacionIpe === "Output de EUC" && realizaFiltro === "Si" && regeneraIpe === "No" && realizaTransformacion === "No")) || (fuente === 1 && clasificacionIpe === "Query Tecnología" && realizaFiltro === "Si" && regeneraIpe === "No" && realizaTransformacion === "No")) || (fuente === 1 && clasificacionIpe === "Query Usuario" && realizaFiltro === "Si" && regeneraIpe === "Si" && realizaTransformacion === "Si")) || (fuente === 1 && clasificacionIpe === "Query Usuario" && realizaFiltro === "Si" && regeneraIpe === "No" && realizaTransformacion === "Si")) ||  (fuente === 1 && clasificacionIpe === "Query Usuario" && realizaFiltro === "Si" && regeneraIpe === "Si" && realizaTransformacion === "No")) ||  (fuente === 1 && clasificacionIpe === "Query Usuario" && realizaFiltro === "Si" && regeneraIpe === "No" && realizaTransformacion === "No"))
          ? (
              <Row className="mb-4">
              <Col sm={8} xs={12}>
                <label>
                  A1. Controles input + Pantalla de los parámetros(filtros) ingresados en el
                  aplicativo*
                </label>
              </Col>
              <Col sm={4} xs={12}>
                <Radio
                  value = "A1"
                  onChange={(event) => {
                    handleChange(event);
                    camposDinamicos();
                  }}
                  name="radio-buttons"
                  checked={checkedA1}
                />
              </Col>
            </Row>): 
            null
            }
          {(((((((((((((((((((((((fuente === 4 && clasificacionIpe === "Query Usuario" && realizaFiltro === "Si" && regeneraIpe === "Si" && realizaTransformacion === "No") || fuente === 1 && clasificacionIpe === "Estándar/Customizado" && realizaFiltro === "No" && realizaTransformacion === "Si" && regeneraIpe === "Si") || (fuente === 1 && clasificacionIpe === "Estándar/Customizado" && realizaFiltro === "Si" && realizaTransformacion === "Si" && regeneraIpe === "Si")) || (fuente === 1 && clasificacionIpe === "Estándar/Customizado" && realizaFiltro === "No" && realizaTransformacion === "Si" && regeneraIpe === "No")) || (fuente === 1 && clasificacionIpe === "Estándar/Customizado" && realizaFiltro === "Si" && realizaTransformacion === "Si" && regeneraIpe === "No")) || (fuente === 1 && clasificacionIpe === "Query Tecnología" && realizaFiltro === "No" && realizaTransformacion === "Si" && regeneraIpe === "Si")) || (fuente === 1 && clasificacionIpe === "Query Tecnología" && realizaFiltro === "Si" && realizaTransformacion === "Si" && regeneraIpe === "Si")) || (fuente === 1 && clasificacionIpe === "Query Tecnología" && realizaFiltro === "No" && realizaTransformacion === "Si" && regeneraIpe === "No")) || (fuente === 1 && clasificacionIpe === "Query Tecnología" && realizaFiltro === "Si" && realizaTransformacion === "Si" && regeneraIpe === "No")) || (fuente === 4 && clasificacionIpe === "Hoja de cálculo" && realizaFiltro === "No Aplica" && realizaTransformacion === "No Aplica" && regeneraIpe === "No Aplica")) || (fuente === 1 && clasificacionIpe === "Otros Documentos" && realizaFiltro === "No Aplica" && realizaTransformacion === "No Aplica" && regeneraIpe === "No Aplica"))|| (fuente === 5 && clasificacionIpe === "Output de EUC" && realizaFiltro === "No" && realizaTransformacion === "Si" && regeneraIpe === "Si")) || (fuente === 5 && clasificacionIpe === "Output de EUC" && realizaFiltro === "Si" && realizaTransformacion === "Si" && regeneraIpe === "Si"))) || (fuente === 5 && clasificacionIpe === "Output de EUC" && realizaFiltro === "No" && realizaTransformacion === "Si" && regeneraIpe === "No"))|| (fuente === 5 && clasificacionIpe === "Output de EUC" && realizaFiltro === "Si" && realizaTransformacion === "Si" && regeneraIpe === "No")) ||  (fuente === 4 && clasificacionIpe === "Otros Documentos" && realizaFiltro === "No Aplica" && realizaTransformacion === "No Aplica" && regeneraIpe === "No Aplica"))|| (fuente === 2 && clasificacionIpe === "Otros Documentos" && realizaFiltro === "No Aplica" && realizaTransformacion === "No Aplica" && regeneraIpe === "No Aplica")) || (fuente === 2 && clasificacionIpe === "Hoja de cálculo" && realizaFiltro === "No Aplica" && realizaTransformacion === "No Aplica" && regeneraIpe === "No Aplica")) || (fuente === 1 && clasificacionIpe === "Query Usuario" && realizaFiltro === "Si" && regeneraIpe === "Si" && realizaTransformacion === "Si")) || (fuente === 1 && clasificacionIpe === "Query Usuario" && realizaFiltro === "Si" && regeneraIpe === "No" && realizaTransformacion === "Si")) ||  (fuente === 1 && clasificacionIpe === "Query Usuario" && realizaFiltro === "Si" && regeneraIpe === "Si" && realizaTransformacion === "No")) ||  (fuente === 1 && clasificacionIpe === "Query Usuario" && realizaFiltro === "Si" && regeneraIpe === "No" && realizaTransformacion === "No"))
              ?
            <Row className="mb-4">
              <Col sm={8} xs={12}>
                <label>
                  A2. Controles input + Pantalla del conteo de registros en el aplicativo vs
                  reporte generado*
                </label>
              </Col>
              <Col sm={4} xs={12}>
                <Radio
                  value = "A2"
                  onChange={(event) => {
                    handleChange(event);
                    camposDinamicos();
                  }}
                  name="radio-buttons"
                  checked={checkedA2}
                />
              </Col>
            </Row>
            :  null
          }
          {
            ((((((((((((((((((((((fuente === 4 && clasificacionIpe === "Query Usuario" && realizaFiltro === "Si" && regeneraIpe === "Si" && realizaTransformacion === "No") || fuente === 1 && clasificacionIpe === "Estándar/Customizado" && realizaFiltro === "No" && realizaTransformacion === "Si" && regeneraIpe === "Si") || (fuente === 1 && clasificacionIpe === "Estándar/Customizado" && realizaFiltro === "Si" && realizaTransformacion === "Si" && regeneraIpe === "Si")) || (fuente === 1 && clasificacionIpe === "Estándar/Customizado" && realizaFiltro === "No" && realizaTransformacion === "Si" && regeneraIpe === "No")) || (fuente === 1 && clasificacionIpe === "Estándar/Customizado" && realizaFiltro === "Si" && realizaTransformacion === "Si" && regeneraIpe === "No")) || (fuente === 1 && clasificacionIpe === "Query Tecnología" && realizaFiltro === "No" && realizaTransformacion === "Si" && regeneraIpe === "Si")) || (fuente === 1 && clasificacionIpe === "Query Tecnología" && realizaFiltro === "Si" && realizaTransformacion === "Si" && regeneraIpe === "Si")) || (fuente === 1 && clasificacionIpe === "Query Tecnología" && realizaFiltro === "No" && realizaTransformacion === "Si" && regeneraIpe === "No")) || (fuente === 1 && clasificacionIpe === "Query Tecnología" && realizaFiltro === "Si" && realizaTransformacion === "Si" && regeneraIpe === "No")) || (fuente === 4 && clasificacionIpe === "Hoja de cálculo" && realizaFiltro === "No Aplica" && realizaTransformacion === "No Aplica" && regeneraIpe === "No Aplica")) || (fuente === 1 && clasificacionIpe === "Otros Documentos" && realizaFiltro === "No Aplica" && realizaTransformacion === "No Aplica" && regeneraIpe === "No Aplica"))|| (fuente === 5 && clasificacionIpe === "Output de EUC" && realizaFiltro === "No" && realizaTransformacion === "Si" && regeneraIpe === "Si")) || (fuente === 5 && clasificacionIpe === "Output de EUC" && realizaFiltro === "Si" && realizaTransformacion === "Si" && regeneraIpe === "Si"))) || (fuente === 5 && clasificacionIpe === "Output de EUC" && realizaFiltro === "No" && realizaTransformacion === "Si" && regeneraIpe === "No"))|| (fuente === 5 && clasificacionIpe === "Output de EUC" && realizaFiltro === "Si" && realizaTransformacion === "Si" && regeneraIpe === "No")) ||  (fuente === 4 && clasificacionIpe === "Otros Documentos" && realizaFiltro === "No Aplica" && realizaTransformacion === "No Aplica" && regeneraIpe === "No Aplica"))|| (fuente === 2 && clasificacionIpe === "Otros Documentos" && realizaFiltro === "No Aplica" && realizaTransformacion === "No Aplica" && regeneraIpe === "No Aplica")) || (fuente === 2 && clasificacionIpe === "Hoja de cálculo" && realizaFiltro === "No Aplica" && realizaTransformacion === "No Aplica" && regeneraIpe === "No Aplica") || (fuente === 1 && clasificacionIpe === "Query Usuario" && realizaFiltro === "Si" && regeneraIpe === "Si" && realizaTransformacion === "Si")) || (fuente === 1 && clasificacionIpe === "Query Usuario" && realizaFiltro === "Si" && regeneraIpe === "No" && realizaTransformacion === "Si")) ||  (fuente === 1 && clasificacionIpe === "Query Usuario" && realizaFiltro === "Si" && regeneraIpe === "Si" && realizaTransformacion === "No")) ||  (fuente === 1 && clasificacionIpe === "Query Usuario" && realizaFiltro === "Si" && regeneraIpe === "No" && realizaTransformacion === "No"))
            ?
            <Row className="mb-4">
              <Col sm={8} xs={12}>
                <label>
                  A3. Controles input + Validación de exactitud de los registros del reporte vs
                  aplicativo*
                </label>
              </Col>
              {/* Si se selecciona el checkbox, entonces guardar un "1" en la base de datos, de lo contrario guardar un "0" */}
              <Col sm={4} xs={12}>
                <Radio
                  value = "A3"
                  onChange={(event) => {
                    handleChange(event);
                    camposDinamicos();
                  }}
                  name="radio-buttons"
                  checked={checkedA3}
                />
              </Col>
            </Row>
            : null
          }
        {
          ((((((((((((((((((((((fuente === 4 && clasificacionIpe === "Query Usuario" && realizaFiltro === "Si" && regeneraIpe === "Si" && realizaTransformacion === "No") || fuente === 1 && clasificacionIpe === "Estándar/Customizado" && realizaFiltro === "No" && realizaTransformacion === "Si" && regeneraIpe === "Si") || (fuente === 1 && clasificacionIpe === "Estándar/Customizado" && realizaFiltro === "Si" && realizaTransformacion === "Si" && regeneraIpe === "Si")) || (fuente === 1 && clasificacionIpe === "Estándar/Customizado" && realizaFiltro === "No" && realizaTransformacion === "Si" && regeneraIpe === "No")) || (fuente === 1 && clasificacionIpe === "Estándar/Customizado" && realizaFiltro === "Si" && realizaTransformacion === "Si" && regeneraIpe === "No")) || (fuente === 1 && clasificacionIpe === "Query Tecnología" && realizaFiltro === "No" && realizaTransformacion === "Si" && regeneraIpe === "Si")) || (fuente === 1 && clasificacionIpe === "Query Tecnología" && realizaFiltro === "Si" && realizaTransformacion === "Si" && regeneraIpe === "Si")) || (fuente === 1 && clasificacionIpe === "Query Tecnología" && realizaFiltro === "No" && realizaTransformacion === "Si" && regeneraIpe === "No")) || (fuente === 1 && clasificacionIpe === "Query Tecnología" && realizaFiltro === "Si" && realizaTransformacion === "Si" && regeneraIpe === "No")) || (fuente === 4 && clasificacionIpe === "Hoja de cálculo" && realizaFiltro === "No Aplica" && realizaTransformacion === "No Aplica" && regeneraIpe === "No Aplica")) || (fuente === 1 && clasificacionIpe === "Otros Documentos" && realizaFiltro === "No Aplica" && realizaTransformacion === "No Aplica" && regeneraIpe === "No Aplica"))|| (fuente === 5 && clasificacionIpe === "Output de EUC" && realizaFiltro === "No" && realizaTransformacion === "Si" && regeneraIpe === "Si")) || (fuente === 5 && clasificacionIpe === "Output de EUC" && realizaFiltro === "Si" && realizaTransformacion === "Si" && regeneraIpe === "Si"))) || (fuente === 5 && clasificacionIpe === "Output de EUC" && realizaFiltro === "No" && realizaTransformacion === "Si" && regeneraIpe === "No"))|| (fuente === 5 && clasificacionIpe === "Output de EUC" && realizaFiltro === "Si" && realizaTransformacion === "Si" && regeneraIpe === "No")) ||  (fuente === 4 && clasificacionIpe === "Otros Documentos" && realizaFiltro === "No Aplica" && realizaTransformacion === "No Aplica" && regeneraIpe === "No Aplica"))|| (fuente === 2 && clasificacionIpe === "Otros Documentos" && realizaFiltro === "No Aplica" && realizaTransformacion === "No Aplica" && regeneraIpe === "No Aplica")) || (fuente === 2 && clasificacionIpe === "Hoja de cálculo" && realizaFiltro === "No Aplica" && realizaTransformacion === "No Aplica" && regeneraIpe === "No Aplica") || (fuente === 1 && clasificacionIpe === "Query Usuario" && realizaFiltro === "Si" && regeneraIpe === "Si" && realizaTransformacion === "Si")) || (fuente === 1 && clasificacionIpe === "Query Usuario" && realizaFiltro === "Si" && regeneraIpe === "No" && realizaTransformacion === "Si")) ||  (fuente === 1 && clasificacionIpe === "Query Usuario" && realizaFiltro === "Si" && regeneraIpe === "Si" && realizaTransformacion === "No")) ||  (fuente === 1 && clasificacionIpe === "Query Usuario" && realizaFiltro === "Si" && regeneraIpe === "No" && realizaTransformacion === "No"))
          ?
          <Row className="mb-4">
            <Col sm={8} xs={12}>
              <label>B. Controles input + Validación por otro control*</label>
            </Col>
            <Col sm={4} xs={12}>
              <Radio
                value = "B"
                onChange={(event) => {
                  handleChange(event);
                }}
                name="radio-buttons"
                checked={checkedB}
              />
            </Col>
          </Row>
          : null
        }
        {
        ((((((((((((((((((((((((fuente === 4 && clasificacionIpe === "Query Usuario" && realizaFiltro === "Si" && regeneraIpe === "Si" && realizaTransformacion === "No") || fuente === 1 && clasificacionIpe === "Estándar/Customizado" && realizaFiltro === "No" && realizaTransformacion === "Si" && regeneraIpe === "Si") || (fuente === 1 && clasificacionIpe === "Estándar/Customizado" && realizaFiltro === "Si" && realizaTransformacion === "Si" && regeneraIpe === "Si")) || (fuente === 1 && clasificacionIpe === "Estándar/Customizado" && realizaFiltro === "No" && realizaTransformacion === "Si" && regeneraIpe === "No")) || (fuente === 1 && clasificacionIpe === "Estándar/Customizado" && realizaFiltro === "Si" && realizaTransformacion === "Si" && regeneraIpe === "No")) || (fuente === 1 && clasificacionIpe === "Query Tecnología" && realizaFiltro === "No" && realizaTransformacion === "Si" && regeneraIpe === "Si")) || (fuente === 1 && clasificacionIpe === "Query Tecnología" && realizaFiltro === "Si" && realizaTransformacion === "Si" && regeneraIpe === "Si")) || (fuente === 1 && clasificacionIpe === "Query Tecnología" && realizaFiltro === "No" && realizaTransformacion === "Si" && regeneraIpe === "No")) || (fuente === 1 && clasificacionIpe === "Query Tecnología" && realizaFiltro === "Si" && realizaTransformacion === "Si" && regeneraIpe === "No")) || (fuente === 4 && clasificacionIpe === "Hoja de cálculo" && realizaFiltro === "No Aplica" && realizaTransformacion === "No Aplica" && regeneraIpe === "No Aplica")) || (fuente === 1 && clasificacionIpe === "Otros Documentos" && realizaFiltro === "No Aplica" && realizaTransformacion === "No Aplica" && regeneraIpe === "No Aplica"))|| (fuente === 5 && clasificacionIpe === "Output de EUC" && realizaFiltro === "No" && realizaTransformacion === "Si" && regeneraIpe === "Si")) ||  (fuente === 5 && clasificacionIpe === "Output de EUC" && realizaFiltro === "Si" && realizaTransformacion === "Si" && regeneraIpe === "Si"))) || (fuente === 5 && clasificacionIpe === "Output de EUC" && realizaFiltro === "No" && realizaTransformacion === "Si" && regeneraIpe === "No"))|| (fuente === 5 && clasificacionIpe === "Output de EUC" && realizaFiltro === "Si" && realizaTransformacion === "Si" && regeneraIpe === "No")) ||  (fuente === 4 && clasificacionIpe === "Otros Documentos" && realizaFiltro === "No Aplica" && realizaTransformacion === "No Aplica" && regeneraIpe === "No Aplica"))|| (fuente === 2 && clasificacionIpe === "Otros Documentos" && realizaFiltro === "No Aplica" && realizaTransformacion === "No Aplica" && regeneraIpe === "No Aplica")) || (fuente === 2 && clasificacionIpe === "Hoja de cálculo" && realizaFiltro === "No Aplica" && realizaTransformacion === "No Aplica" && regeneraIpe === "No Aplica") || (fuente === 1 && clasificacionIpe === "Query Usuario" && realizaFiltro === "Si" && regeneraIpe === "Si" && realizaTransformacion === "Si")) || (fuente === 1 && clasificacionIpe === "Query Usuario" && realizaFiltro === "Si" && regeneraIpe === "No" && realizaTransformacion === "Si")) ||  (fuente === 1 && clasificacionIpe === "Query Usuario" && realizaFiltro === "Si" && regeneraIpe === "Si" && realizaTransformacion === "No")) ||  (fuente === 1 && clasificacionIpe === "Query Usuario" && realizaFiltro === "Si" && regeneraIpe === "No" && realizaTransformacion === "No")) || (fuente === 1 && clasificacionIpe === "Estándar/Customizado" && realizaFiltro === "Si" && regeneraIpe === "No" && realizaTransformacion === "No") || (fuente === 5 && clasificacionIpe === "Output de EUC" && realizaFiltro === "Si" && regeneraIpe === "No" && realizaTransformacion === "No")) || (fuente === 1 && clasificacionIpe === "Query Tecnología" && realizaFiltro === "Si" && regeneraIpe === "No" && realizaTransformacion === "No")) 
          ?
          <Row className="mb-4">
            <Col sm={8} xs={12}>
              <label>C. Controles input + Validación por el mismo control*</label>
            </Col>
            <Col sm={4} xs={12}>
              <Radio
                value = "C"
                onChange={(event) => {
                  handleChange(event);
                  camposDinamicos();
                }}
                name="radio-buttons"
                checked={checkedC}
              />
            </Col>
          </Row>
          : null
        }
        {
          ((((((((((((((((((((((fuente === 4 && clasificacionIpe === "Query Usuario" && realizaFiltro === "Si" && regeneraIpe === "Si" && realizaTransformacion === "No") || fuente === 1 && clasificacionIpe === "Estándar/Customizado" && realizaFiltro === "No" && realizaTransformacion === "Si" && regeneraIpe === "Si") || (fuente === 1 && clasificacionIpe === "Estándar/Customizado" && realizaFiltro === "Si" && realizaTransformacion === "Si" && regeneraIpe === "Si")) || (fuente === 1 && clasificacionIpe === "Estándar/Customizado" && realizaFiltro === "No" && realizaTransformacion === "Si" && regeneraIpe === "No")) || (fuente === 1 && clasificacionIpe === "Estándar/Customizado" && realizaFiltro === "Si" && realizaTransformacion === "Si" && regeneraIpe === "No")) || (fuente === 1 && clasificacionIpe === "Query Tecnología" && realizaFiltro === "No" && realizaTransformacion === "Si" && regeneraIpe === "Si")) || (fuente === 1 && clasificacionIpe === "Query Tecnología" && realizaFiltro === "Si" && realizaTransformacion === "Si" && regeneraIpe === "Si")) || (fuente === 1 && clasificacionIpe === "Query Tecnología" && realizaFiltro === "No" && realizaTransformacion === "Si" && regeneraIpe === "No")) || (fuente === 1 && clasificacionIpe === "Query Tecnología" && realizaFiltro === "Si" && realizaTransformacion === "Si" && regeneraIpe === "No")) || (fuente === 4 && clasificacionIpe === "Hoja de cálculo" && realizaFiltro === "No Aplica" && realizaTransformacion === "No Aplica" && regeneraIpe === "No Aplica")) || (fuente === 1 && clasificacionIpe === "Otros Documentos" && realizaFiltro === "No Aplica" && realizaTransformacion === "No Aplica" && regeneraIpe === "No Aplica"))|| (fuente === 5 && clasificacionIpe === "Output de EUC" && realizaFiltro === "No" && realizaTransformacion === "Si" && regeneraIpe === "Si")) || (fuente === 5 && clasificacionIpe === "Output de EUC" && realizaFiltro === "Si" && realizaTransformacion === "Si" && regeneraIpe === "Si"))) || (fuente === 5 && clasificacionIpe === "Output de EUC" && realizaFiltro === "No" && realizaTransformacion === "Si" && regeneraIpe === "No"))|| (fuente === 5 && clasificacionIpe === "Output de EUC" && realizaFiltro === "Si" && realizaTransformacion === "Si" && regeneraIpe === "No")) ||  (fuente === 4 && clasificacionIpe === "Otros Documentos" && realizaFiltro === "No Aplica" && realizaTransformacion === "No Aplica" && regeneraIpe === "No Aplica"))|| (fuente === 2 && clasificacionIpe === "Otros Documentos" && realizaFiltro === "No Aplica" && realizaTransformacion === "No Aplica" && regeneraIpe === "No Aplica")) || (fuente === 2 && clasificacionIpe === "Hoja de cálculo" && realizaFiltro === "No Aplica" && realizaTransformacion === "No Aplica" && regeneraIpe === "No Aplica") || (fuente === 1 && clasificacionIpe === "Query Usuario" && realizaFiltro === "Si" && regeneraIpe === "Si" && realizaTransformacion === "Si")) || (fuente === 1 && clasificacionIpe === "Query Usuario" && realizaFiltro === "Si" && regeneraIpe === "No" && realizaTransformacion === "Si")) ||  (fuente === 1 && clasificacionIpe === "Query Usuario" && realizaFiltro === "Si" && regeneraIpe === "Si" && realizaTransformacion === "No")) || (fuente === 1 && clasificacionIpe === "Query Usuario" && realizaFiltro === "Si" && regeneraIpe === "No" && realizaTransformacion === "No"))
          ?
          <Row className="mb-4">
            <Col sm={8} xs={12}>
              <label>
                D. Controles input + Validación de la IPE por actividades diferentes a controles*
              </label>
            </Col>
            <Col sm={4} xs={12}>
              <Radio
                value = "D"
                onChange={(event) => {
                  handleChange(event);
                  camposDinamicos();
                }}
                name="radio-buttons"
                checked={checkedD}
              />
            </Col>
          </Row>
          : null
        }
        {
            ((((((((((((((((fuente === 1 && clasificacionIpe === "Estándar/Customizado" && realizaFiltro === "No" && realizaTransformacion === "Si" && regeneraIpe === "Si") || (fuente === 1 && clasificacionIpe === "Estándar/Customizado" && realizaFiltro === "Si" && realizaTransformacion === "Si" && regeneraIpe === "Si")) || (fuente === 1 && clasificacionIpe === "Estándar/Customizado" && realizaFiltro === "No" && realizaTransformacion === "Si" && regeneraIpe === "No")) || (fuente === 1 && clasificacionIpe === "Estándar/Customizado" && realizaFiltro === "Si" && realizaTransformacion === "Si" && regeneraIpe === "No")) || (fuente === 1 && clasificacionIpe === "Query Tecnología" && realizaFiltro === "No" && realizaTransformacion === "Si" && regeneraIpe === "Si")) || (fuente === 1 && clasificacionIpe === "Query Tecnología" && realizaFiltro === "Si" && realizaTransformacion === "Si" && regeneraIpe === "Si")) || (fuente === 1 && clasificacionIpe === "Query Tecnología" && realizaFiltro === "No" && realizaTransformacion === "Si" && regeneraIpe === "No")) || (fuente === 1 && clasificacionIpe === "Query Tecnología" && realizaFiltro === "Si" && realizaTransformacion === "Si" && regeneraIpe === "No")) || (fuente === 1 && clasificacionIpe === "Estándar/Customizado" && realizaFiltro === "Si" && regeneraIpe === "No" && realizaTransformacion === "No")) || (fuente === 1 && clasificacionIpe === "Query Tecnología" && realizaFiltro === "Si" && regeneraIpe === "No" && realizaTransformacion === "No")) || (fuente === 1 && clasificacionIpe === "Estándar/Customizado" && realizaFiltro === "No" && realizaTransformacion === "No" && regeneraIpe === "Si")) || (fuente === 1 && clasificacionIpe === "Estándar/Customizado" && realizaFiltro === "Si" && realizaTransformacion === "No" && regeneraIpe === "Si")) || (fuente === 1 && clasificacionIpe === "Estándar/Customizado" && realizaFiltro === "No" && realizaTransformacion === "No" && regeneraIpe === "No")) || (fuente === 1 && clasificacionIpe === "Query Tecnología" && realizaFiltro === "No" && realizaTransformacion === "No" && regeneraIpe === "Si")) || (fuente === 1 && clasificacionIpe === "Query Tecnología" && realizaFiltro === "Si" && realizaTransformacion === "No" && regeneraIpe === "Si")) || (fuente === 1 && clasificacionIpe === "Query Tecnología" && realizaFiltro === "No" && realizaTransformacion === "No" && regeneraIpe === "No"))
        ?
          <Row className="mb-4">
            <Col sm={8} xs={12}>
              <label>
                 Controles Input + Controles ITGC
              </label>
            </Col>
            <Col sm={4} xs={12}>
              <Radio
                onChange={(event) => {}}
                name="radio-buttons"
                checked= {true}
              />
            </Col>
          </Row>
          : null
        }

        {   
           (((((((((fuente === 5 && clasificacionIpe === "Output de EUC" && realizaFiltro === "No" && realizaTransformacion === "Si" && regeneraIpe === "Si")) || (fuente === 5 && clasificacionIpe === "Output de EUC" && realizaFiltro === "Si" && realizaTransformacion === "Si" && regeneraIpe === "Si")) || (fuente === 5 && clasificacionIpe === "Output de EUC" && realizaFiltro === "No" && realizaTransformacion === "Si" && regeneraIpe === "No"))|| (fuente === 5 && clasificacionIpe === "Output de EUC" && realizaFiltro === "Si" && realizaTransformacion === "Si" && regeneraIpe === "No")) || (fuente === 5 && clasificacionIpe === "Output de EUC" && realizaFiltro === "Si" && regeneraIpe === "No" && realizaTransformacion === "No"))|| (fuente === 5 && clasificacionIpe === "Output de EUC" && realizaFiltro === "No" && realizaTransformacion === "No" &&  regeneraIpe === "Si")) || (fuente === 5 && clasificacionIpe === "Output de EUC" && realizaFiltro === "No" && realizaTransformacion === "No" && regeneraIpe === "No")) ||  (fuente === 5 && clasificacionIpe === "Output de EUC" && realizaFiltro === "Si" && realizaTransformacion === "No" && regeneraIpe === "Si"))
            ? 
            (
              <Row className="mb-4">
              <Col sm={8} xs={12}>
                <label>
                  Controles Input + Política EUC
                </label>
              </Col>
              <Col sm={4} xs={12}>
                <Radio
                  checked={true}
                  value="PoliticaEuc"
                  onChange={(event) => {}}
                  name="radio-buttons"
                />
              </Col>
              </Row>
              )
            :
              null
          }
        {(((fuente === 4 && clasificacionIpe === "Documentos Externos" && realizaFiltro === "No Aplica" && realizaTransformacion === "No Aplica" && regeneraIpe === "No Aplica"))|| (fuente === 1 && clasificacionIpe === "Documentos Externos" && realizaFiltro === "No Aplica" && realizaTransformacion === "No Aplica" && regeneraIpe === "No Aplica")) ? 
        <Row className="mb-4">
        <Col sm={8} xs={12}>
          <label>
          E. Información suministrada por un tercero - SSAE
          </label>
        </Col>
        <Col sm={4} xs={12}>
          <Radio
            checked={true}
            value="AplicarE"
            onChange={(event) => {}}
            name="radio-buttons"
          />
        </Col>
        </Row>
          :
          null
          }
          {/* Si fuente_de_generacion es "Proveedor" mostrar el siguiente Row*/}
          {dataAnexoEditar ? (
            
            <Row className="mb-4">
              <Col sm={8} xs={12}>
                <label>E. Información suministrada por un tercero - SSAE</label>
              </Col>
              <Paper className={classes.root}>
                <TableContainer component={Paper} className={classes.container}>
                  <Table
                    className={"text"}
                    stickyHeader
                    aria-label="sticky table"
                    onChange={(e) => {
                      setcheckedE(e.target.checked);
                    }}
                  >
                    {/* Inicio de encabezado */}
                    <TableHead className="titulo">
                      <TableRow>
                        <StyledTableCell align="left">
                          Tipo de Anexo
                        </StyledTableCell>

                        <StyledTableCell align="left">
                          Vigencia hasta
                        </StyledTableCell>

                        <StyledTableCell align="left">
                          Entidad que avala
                        </StyledTableCell>
                      </TableRow>
                    </TableHead>
                    {/* Fin de encabezado */}
                    {/* Inicio de cuerpo de la tabla */}
                    {/*GetAnexoProveedor(dataProveedor[0]?.ID_SAP)*/}
                    <TableBody>
                      {/*Traer la información de dataAnexo por medio de .map*/}
                      {dataAnexoEditar.map((row) => {
                        return (
                          <TableRow>
                            <StyledTableCell align="left">
                              {row.tipo}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              {row.fecha_vigencia}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              {row.entidad}
                            </StyledTableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                    {/* Fin de cuerpo de la tabla */}
                  </Table>
                </TableContainer>
              </Paper>
            </Row>
          ) : null}
          {dataProveedor[0]?.Nombre_Proveedor ? (
            <Row className="mb-4">
              <Col sm={8} xs={12}>
                <label>E. Información suministrada por un tercero - SSAE</label>
              </Col>
              <Paper className={classes.root}>
                <TableContainer component={Paper} className={classes.container}>
                  <Table
                    className={"text"}
                    stickyHeader
                    aria-label="sticky table"
                    onChange={(e) => {
                      setcheckedE(e.target.checked);
                    }}
                  >
                    {/* Inicio de encabezado */}
                    <TableHead className="titulo">
                      <TableRow>
                        <StyledTableCell align="left">
                          Tipo de Anexo
                        </StyledTableCell>

                        <StyledTableCell align="left">
                          Vigencia hasta
                        </StyledTableCell>

                        <StyledTableCell align="left">
                          Entidad que avala
                        </StyledTableCell>
                      </TableRow>
                    </TableHead>
                    {/* Fin de encabezado */}
                    {/* Inicio de cuerpo de la tabla */}
                    {/*GetAnexoProveedor(dataProveedor[0]?.ID_SAP)*/}
                    <TableBody>
                      {/*Traer la información de dataAnexo por medio de .map*/}
                      {dataAnexo.map((row) => {
                        return (
                          <TableRow>
                            <StyledTableCell align="left">
                              {row.tipo}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              {row.fecha_vigencia}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                              {row.entidad}
                            </StyledTableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                    {/* Fin de cuerpo de la tabla */}
                  </Table>
                </TableContainer>
              </Paper>
            </Row>
          ) : null}
          {/*controles despues de los checkbox */}
          <Row className="mb-3">
            <Col sm={6} xs={12}>
              <label className="form-label label">
              Controles para asegurar la construcción de la IPE
              </label>
            </Col>

            <Col sm={2} xs={12}>
              <button
                type="button"
                className="btn botonPositivo"
                onClick={() => {setShowAsociarControles(true)
                setFlagAsegura(true)
                }}
              >
                Asociar
              </button>
            </Col>
            <Col sm={2} xs={12}>
              <button
                type="button"
                className="btn botonNegativo"
                onClick={DesasociarControlCheckbox}
              >
                Desasociar
              </button>
            </Col>
          </Row>
          <Row className="mb-4">
            <Paper className={classes.root}>
              <TableContainer component={Paper} className={classes.container}>
                <Table
                  className={"text"}
                  stickyHeader
                  aria-label="sticky table"
                >
                  {/* Inicio de encabezado */}
                  <TableHead className="titulo">
                    <TableRow>
                      <StyledTableCell padding="checkbox"></StyledTableCell>

                      <StyledTableCell align="left">ID Control</StyledTableCell>

                      <StyledTableCell align="left">Control</StyledTableCell>

                      <StyledTableCell align="left">Proceso</StyledTableCell>

                      <StyledTableCell align="left">Estado</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  {/* Fin de encabezado */}
                  {/* Inicio de cuerpo de la tabla */}
                  <TableBody>
                    
                    {dataControlesCheckbox.map((row, index) => {
                      const isItemSelected = isSelectedControles(row.idcontrol);
                      
                      return (
                        <StyledTableRow
                          key={row.idcontrol}
                          hover
                          onClick={(event) =>
                            handleClickControles(event, row.idcontrol)
                          }
                          selected={isItemSelected}
                          role="checkbox"
                          tabIndex={-1}
                        >
                          <StyledTableCell component="th" scope="row">
                            <Checkbox checked={isItemSelected} />
                          </StyledTableCell>

                          <StyledTableCell component="th" scope="row">
                            {row.idcontrol ? row.idcontrol : null}
                          </StyledTableCell>

                          <StyledTableCell align="left">
                            {row.nombre ? row.nombre : null}
                          </StyledTableCell>

                          <StyledTableCell align="left">
                            {row.proceso ? row.proceso : null}
                          </StyledTableCell>

                          <StyledTableCell align="left">
                            {row.estado ? row.estado : null}
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    })}
                  </TableBody>
                  {/* Fin de cuerpo de la tabla */}
                </Table>
              </TableContainer>
            </Paper>
          </Row>
          {/*fin controles despues de los checkbox */}

          <Row className="mb-4">
            <Col sm={6} xs={12}>
              <label>Actividades de mitigación</label>
            </Col>
            <Col sm={6} xs={12}>
              <textarea
                {...register("otros_controles")}
                onChange={(e) => {
                  setOtrosControles(e.target.value);
                }}
                type="text"
                className="form-control text-center"
                rows="3"
              />
            </Col>
          </Row>

          <Row className="mb-3 mt-4">
            <Col md={12}>
              <h1 class="subtitulo text-left">Atributos de la Ipe</h1>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col sm={3} xs={3}>
              <button
                type="button"
                className="btn botonPositivo2"
                onClick={async (e) => {
                  addRowAtributos(e);
                }}
              >
                Agregar
              </button>
            </Col>
            <Col sm={3} xs={3}>
              <button
                type="button"
                className="btn botonNegativo2"
                onClick={(e) => {
                  let tempRev = dataAtributos;
                  tempRev = tempRev.filter((obj) => obj.id !== selected[0]);
                  setDataAtributos(tempRev);
                }}
              >
                Eliminar
              </button>
            </Col>
            <Col sm={6} xs={1}></Col>
          </Row>
          
          <Paper className={classes.root}>
            <TableContainer component={Paper} className={classes.container}>
              <Table className={"text"} stickyHeader aria-label="sticky table">
                {/* Inicio de encabezado */}
                <TableHead className="titulo">
                  <TableRow className="tr">
                    <StyledTableCell padding="checkbox"></StyledTableCell>
                    <StyledTableCell align="left">
                      Nombre atributo
                    </StyledTableCell>
                    {/* <StyledTableCell align="left">Usuario</StyledTableCell> */}
                    <StyledTableCell align="left">
                      Fuente atributo
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      Área donde se captura el atributo
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      Proceso donde se captura el atributo
                    </StyledTableCell>
                    {/* <StyledTableCell align="left">Estado</StyledTableCell>
                    <StyledTableCell align="left">
                      Fecha inactivación
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      Justificación de inactivación
                    </StyledTableCell> */}
                    <StyledTableCell align="left">Controles</StyledTableCell>
                    <StyledTableCell align="left">
                      Otros controles
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                {/* Fin de encabezado */}
                {/* Inicio de cuerpo de la tabla */}
                <TableBody>
                  {dataAtributos
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                      const isItemSelected = isSelected(row.id);
                      return (
                        <StyledTableRow
                          key={row.id}
                          hover
                          onClick={(event) => handleClick(event, row.id)}
                          selected={isItemSelected}
                          role="checkbox"
                          tabIndex={-1}
                        >
                          <StyledTableCell component="th" scope="row">
                            <Checkbox checked={isItemSelected} />
                          </StyledTableCell>

                          <StyledTableCell align="left">
                            <input
                              placeholder="Nombre de Atributo"
                              id="nombre"
                              name="nombre"
                              defaultValue={row.nombre ? row.nombre : null}
                              onChange={(e) => {
                                row["nombre"] = e.target.value;
                              }}
                            ></input>
                          </StyledTableCell>
                          {/* <StyledTableCell align="left">
                            {row.usuario_creador !== null
                              ? row.usuario_creador
                              : null}
                          </StyledTableCell> */}
                          <StyledTableCell align="left">
                            {/* <Select
                              options={[
                                { label: "Si", value: "Si" },
                                { label: "No", value: "No" },
                                { label: "No Aplica", value: "No Aplica" },
                              ]}
                              placeholder={"Integridad y exactitud"}
                              onChange={(e) => {
                                row["integridad_y_exactitud"] = e.value;
                              }}
                            /> */}
                            <input
                              placeholder="Fuente de atributo"
                              id="fuenteAtributo"
                              name="fuenteAtributo"
                              defaultValue={
                                row.fuente_atributo ? row.fuente_atributo : null
                              }
                              onChange={(e) => {
                                row["fuente_atributo"] = e.target.value;
                              }}
                            ></input>
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            <Select
                              options={dataArea}
                              placeholder={"Área donde se captura"}
                              value={
                                row.area_captura
                                  ? {
                                      label: row.area_captura,
                                      value: row.idarea_captura,
                                    }
                                  : null
                              }
                              onChange={(e) => {
                                row["area_captura"] = e.label;
                                row["idarea_captura"] = e.value;
                              }}
                            />
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            <Select
                              options={dataProceso}
                              value={
                                row.proceso_captura
                                  ? {
                                      label: row.proceso_captura,
                                      value: row.idproceso_captura,
                                    }
                                  : null
                              }
                              placeholder={"Proceso donde se captura"}
                              {...register("proceso_captura")}
                              onChange={(e) => {
                                row["proceso_captura"] = e.label;
                                row["idproceso_captura"] = e.value;
                              }}
                            />
                          </StyledTableCell>
                          {/* <StyledTableCell align="left">
                            <Select
                              options={[
                                { label: "Activo", value: 1 },
                                { label: "Inactivo", value: 0 },
                              ]}
                              value={
                                row.estado
                                  ? {
                                      label: row.estado,
                                      value: row.estado,
                                    }
                                  : null
                              }
                              placeholder={"Estado atributo"}
                              onChange={(e) => {
                                row["estado"] = e.value;
                              }}
                            />
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {/* <Select
                              options={[
                                { label: "Adecuado", value: "Adecuado" },
                                { label: "Por mejorar", value: "Por mejorar" },
                              ]}
                              placeholder={"Resultados evaluación"}
                              onChange={(e) => {
                                row["resultados_evaluacion"] = e.value;
                              }}
                            /> 
                            <input
                              type="date"
                              id="fechaInactivacion_atributos"
                              placeholder="yyyy/mm/dd"
                              className="form-control text-center texto"
                              name="fechaInactivacion_atributos"
                              defaultValue={
                                row.fecha_inactivacion
                                  ? row.fecha_inactivacion
                                  : null
                              }
                              onChange={(e) => {
                                row["fecha_inactivacion"] = e.target.value;
                              }}
                            ></input>
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            <textarea
                              className="form-control text-left"
                              placeholder="Justificación inactivacion"
                              rows="3"
                              id="justificacion_inactivacion"
                              value={
                                row.justificacion_inactivacion
                                  ? {
                                      label: row.justificacion_inactivacion,
                                      name: row.justificacion_inactivacion,
                                    }
                                  : null
                              }
                              onChange={(e) => {
                                row["justificacion_inactivacion"] =
                                  e.target.value;
                              }}
                            ></textarea>
                            </StyledTableCell> */}
                          <StyledTableCell align="left">
                            <label>
                              {row.idControles ? row.idControles : null}
                            </label>
                            <Button
                              variant="text"
                              title="Agregar"
                              onClick={async () => {
                                await openControlsModal(row, index);
                              }}
                            >
                              <AddBoxIcon color="info" />
                            </Button>
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            <textarea
                              className="form-control text-left"
                              placeholder="Otros controles atributos"
                              rows="3"
                              id="otrosControlesAtributos"
                              defaultValue={
                                row.otros_controles ? row.otros_controles : null
                              }
                              onChange={(e) => {
                                row["otros_controles"] = e.target.value;
                              }}
                            ></textarea>
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    })}
                </TableBody>
                {/* Fin de cuerpo de la tabla */}
              </Table>
            </TableContainer>
          </Paper>

          {!props.idrol.includes(3) ? (
          <>
          

          <Row className="mb-4">
            <Col sm={12} xs={12}>
              <hr />
              <label className="form-label label">
                Revisión y reto de segunda línea
              </label>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col sm={3} xs={3}>
              <button
                type="button"
                className="btn botonPositivo2"
                onClick={async (e) => {
                  addRowRevision(e);
                }}
              >
                Agregar
              </button>
            </Col>
            <Col sm={3} xs={3}>
              <button
                type="button"
                className="btn botonNegativo2"
                onClick={(e) => {
                  let tempRev = dataRevision;
                  tempRev = tempRev.filter((obj) => obj.id !== selected[0]);
                  setDataRevision(tempRev);
                }}
              >
                Eliminar
              </button>
            </Col>
            <Col sm={6} xs={1}></Col>
          </Row>
          <Paper className={classes.root}>
            <TableContainer component={Paper} className={classes.container}>
              <Table className={"text"} stickyHeader aria-label="sticky table">
                {/* Inicio de encabezado */}
                <TableHead className="titulo">
                  <TableRow className="tr">
                    <StyledTableCell padding="checkbox"></StyledTableCell>
                    <StyledTableCell align="left">
                      Unidad de riesgo
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      Usuario Creador
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      ¿Se garantiza la generación de la IPE?*
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      ¿Se garantiza la integridad de la salida de la IPE?*
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      ¿Se garantiza la replicabilidad de IPE?*
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      ¿Se garantiza todos los atributos de la IPE?*
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      Resultados de la evaluación de la IPE*
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      Observaciones
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      Id plan de acción
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      Plan de mitigación
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                {/* Fin de encabezado */}
                {/* Inicio de cuerpo de la tabla */}
                <TableBody>
                  {dataRevision
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                      const isItemSelected = isSelected(row.id);
                      return (
                        <StyledTableRow
                          key={row.id}
                          hover
                          onClick={(event) => handleClick(event, row.id)}
                          selected={isItemSelected}
                          role="checkbox"
                          tabIndex={-1}
                        >
                          <StyledTableCell component="th" scope="row">
                            <Checkbox checked={isItemSelected} />
                          </StyledTableCell>

                          <StyledTableCell align="left">
                          {
                                 row.unidad_riesgo
                                 
                              }
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {row.usuario_creador !== null
                              ? row.usuario_creador
                              : null}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            <Select
                              options={[
                                { label: "Si", value: "Si" },
                                { label: "No", value: "No" },
                                { label: "No Aplica", value: "No Aplica" },
                              ]}
                              value={
                                row.integridad_y_exactitud
                                  ? {
                                      label: row.integridad_y_exactitud,
                                      name: row.integridad_y_exactitud,
                                    }
                                  : null
                              }
                              placeholder={"Integridad y exactitud"}
                              onChange={(e) => {
                                row["integridad_y_exactitud"] = e.value;
                              }}
                            />
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            <Select
                              options={[
                                { label: "Si", value: "Si" },
                                { label: "No", value: "No" },
                                { label: "No Aplica", value: "No Aplica" },
                              ]}
                              value={
                                row.integridad_de_salida
                                  ? {
                                      label: row.integridad_de_salida,
                                      name: row.integridad_de_salida,
                                    }
                                  : null
                              }
                              placeholder={"Integridad salida"}
                              onChange={(e) => {
                                row["integridad_de_salida"] = e.value;
                              }}
                            />
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            <Select
                              options={[
                                { label: "Si", value: "Si" },
                                { label: "No", value: "No" },
                                { label: "No Aplica", value: "No Aplica" },
                              ]}
                              value={
                                row.replicabilidad
                                  ? {
                                      label: row.replicabilidad,
                                      name: row.replicabilidad,
                                    }
                                  : null
                              }
                              placeholder={"Replicabilidad"}
                              onChange={(e) => {
                                row["replicabilidad"] = e.value;
                              }}
                            />
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            <Select
                              options={[
                                { label: "Si", value: "Si" },
                                { label: "No", value: "No" },
                                { label: "No Aplica", value: "No Aplica" },
                              ]}
                              value={
                                row.garantiza_atributos
                                  ? {
                                      label: row.garantiza_atributos,
                                      name: row.garantiza_atributos,
                                    }
                                  : null
                              }
                              placeholder={"Garantiza atributos"}
                              onChange={(e) => {
                                row["garantiza_atributos"] = e.value;
                              }}
                            />
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            <Select
                              options={[
                                { label: "Adecuado", value: "Adecuado" },
                                {
                                  label: "Por mejorar",
                                  value: "Por mejorar",
                                },
                              ]}
                              value={
                                row.resultados_evaluacion
                                  ? {
                                      label: row.resultados_evaluacion,
                                      name: row.resultados_evaluacion,
                                    }
                                  : null
                              }
                              placeholder={"Resultados evaluación"}
                              onChange={(e) => {
                                row["resultados_evaluacion"] = e.value;
                              }}
                            />
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            <textarea
                              className="form-control text-left"
                              placeholder="Observaciones"
                              rows="3"
                              id="Observaciones"
                              defaultValue={
                                row.observaciones ? row.observaciones : null
                              }
                              onChange={(e) => {
                                row["observaciones"] = e.target.value;
                              }}
                            ></textarea>
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            <label>{row.idPAs ? row.idPAs : null}</label>
                            <Button
                              variant="text"
                              title="Agregar"
                              onClick={async () => {
                                await openPAModal(row, index);
                              }}
                            >
                              <AddBoxIcon color="info" />
                            </Button>
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            <textarea
                              className="form-control text-left"
                              placeholder="Descripción del plan de mitigación"
                              rows="3"
                              id="plan_accion"
                              defaultValue={
                                row.plan_accion ? row.plan_accion : null
                              }
                              onChange={(e) => {
                                row["plan_accion"] = e.target.value;
                              }}
                            ></textarea>
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    })}
                </TableBody>
                {/* Fin de cuerpo de la tabla */}
              </Table>
            </TableContainer>
          </Paper>
          </>
          ):null}

        </FormProvider>
      </Container>
      
    </>
    )}
    </>
  );
}
